export default __webpack_public_path__ + "static/renshin-animation-27ac7e7c7339df9e2d72619ddbbb64aa.webm";